// Light/dark toggle. The head bootstrap in layout/theme.liquid sets the first data-theme before paint;
// this element flips it on the `--toggle` command, remembers the shopper's choice, and follows the
// device setting while no explicit choice is stored and the merchant default is "system".
const STORAGE_KEY = 'zonba-theme';

class SThemeToggle extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const root = document.documentElement;

    this.addEventListener('command', (event) => {
      if (event.command !== '--toggle') return;
      const next = root.dataset.theme === 'dark' ? 'light' : 'dark';
      this.#apply(next);
      try { localStorage.setItem(STORAGE_KEY, next); } catch (e) { /* storage unavailable */ }
    }, opts);

    const media = window.matchMedia('(prefers-color-scheme: dark)');
    media.addEventListener('change', (event) => {
      let stored = null;
      try { stored = localStorage.getItem(STORAGE_KEY); } catch (e) { /* storage unavailable */ }
      if (stored || root.dataset.defaultMode !== 'system') return;
      this.#apply(event.matches ? 'dark' : 'light');
    }, opts);

    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #apply(mode) {
    document.documentElement.dataset.theme = mode;
    this.#sync();
  }

  #sync() {
    const isDark = document.documentElement.dataset.theme === 'dark';
    this.querySelectorAll('button[command="--toggle"]').forEach((button) => {
      button.setAttribute('aria-pressed', String(isDark));
    });
  }
}

if (!customElements.get('s-theme-toggle')) customElements.define('s-theme-toggle', SThemeToggle);
